import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import useForm from 'components/FormUse';
import Loading from 'components/Loading';
import InputDateMask from 'components/InputDateMask';
import BonusService from 'services/BonusService/service';
import imgLogoBonus from 'assets/images/bonus/logo-bonus.png';
import { AuthContext } from '../../auth/AuthContext';
import { types } from '../../types/types';
import { documentTypes } from '../../config';
import './style.scss';

const PopupBonusReg = ({ execActionConfirm = null }) => {
    
    const { sessionDispatch } = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(false);
    const [processErrorMsg, setProcessErrorMsg] = useState('');
    const [stepProcess, setStepProcess] = useState(1);
    const [userBonus, setUserBonus] = useState({});
    const handleConfirm = (event) => {
        execActionConfirm && execActionConfirm(event);
    }
    const {
        handleSubmit,
        handleChange,
        data,
        errors,
    } = useForm({
        validations: {
            document_type: {
                required: {
                    value: true, 
                    message: "Seleccione un tipo de documento"
                }
            }, 
            document_number: {
                required: {
                    value: true, 
                    message: "Ingrese un número de documento válido"
                }
            }, 
            birthday: {
                pattern: {
                    value: /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/,//eslint-disable-line
                    message: "Ingrese su fecha de nacimiento con este formato DD/MM/AAAA"
                }
            }
        },
        onSubmit: async (data) => {
            setIsLoading(true);
            setProcessErrorMsg('');
            try{
                const birtharray = data.birthday.split('/');
                const birthday_formatted = birtharray.length===3 ? (`${birtharray[2]}-${birtharray[1]}-${birtharray[0]}`) : '';
                const bonus_data = await BonusService.consulting({
                    tipoDocumento: data.document_type, 
                    numDocumento: data.document_number, 
                    fechaNacimiento: birthday_formatted
                });
                if(!bonus_data || (bonus_data && !['200','201'].includes(bonus_data.internalCode))){
                    setIsLoading(false);
                    setProcessErrorMsg('Ha ocurrido un error en la consulta. Intente nuevamente.');
                    return;
                }
                setUserBonus(bonus_data.payload);
                Promise.all([BonusService.linking({
                    personaCodigo: bonus_data.payload.persona_codigo, 
                    fechaNacimiento: birthday_formatted
                })]).then(linked => {
                    if(!linked || !['200','201'].includes(linked[0].internalCode)){
                        setIsLoading(false);
                        setProcessErrorMsg('No se ha podido vincular su cuenta');
                        return;
                    }
                    sessionDispatch({
                        type: types.change,
                        payload: {
                            fullname: `${bonus_data.payload.nombre_razonsocial} ${bonus_data.payload.apellido_paterno} ${bonus_data.payload.apellido_materno}`,
                            firstname: bonus_data.payload.nombre_razonsocial,
                            lastname: `${bonus_data.payload.apellido_paterno} ${bonus_data.payload.apellido_materno}`,
                            bonus: true                      
                        }
                    });
                    setStepProcess(2);
                });
            }catch(error){
                console.error(error);
            }
        },
        initialValues: {
            document_type: '', 
            document_number: '',
            birthday: ''
        }
    });

    return (
        <div id="message-bonus-step-1" className="white-popup custom-select2">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <form onSubmit={handleSubmit}>
                            <div className="row form">
                                {stepProcess===1
                                    ?
                                    <div className="col-12 step-1">
                                        <p className="text-center">
                                            <img src={imgLogoBonus}/>
                                        </p>
                                        <p className="text-justify text-md-center mt-md-4 mb-md-4">Disfruta de los beneficios personalizados con Bonus</p>
                                        <div className="form-group">
                                            <div className="select2-container">
                                                <select value={data.document_type || ''} onChange={handleChange('document_type')} required className="select2" name="dropDownListTipoDocumento">
                                                    <option value="" disabled>Tipo de documento</option>
                                                    {
                                                        documentTypes.filter(document => (document.cod!=0 &&document.cod!=9)).map(document => <option key={document.cod} value={document.cod}>{document.title}</option>)
                                                    }
                                                </select>
                                            </div>
                                            {errors.document_type && <p className="error-form">{errors.document_type}</p>}
                                        </div>
                                        <div className="form-group">
                                            <input value={data.document_number || ''} onChange={handleChange('document_number')} required maxLength="12" type="text" className="form-control" name="textBoxDocumento" id="textBoxDocumento" placeholder="NÚMERO DE DOCUMENTO" />
                                            {errors.document_number && <p className="error-form">{errors.document_number}</p>}
                                        </div>
                                        <div className="form-group">
                                            <InputDateMask onChangeValue={handleChange} inputKey="birthday" className="form-control" mask="dd/mm/yyyy"/>
                                            {errors.birthday && <p className="error-form">{errors.birthday}</p>}
                                            <div className="date ">* Fecha de Nacimiento</div>
                                        </div>
                                        <div className="row d-none d-md-flex">
                                            {processErrorMsg!=='' && <p className="col-12 text-center" style={{ marginBottom: 0 }}>{processErrorMsg}</p>}
                                            <div className="col-6">
                                                <p className="buttons text-center">
                                                    <button type="button" onClick={(event) => handleConfirm(event)} className="btn btn-primary btn-main no-hover">Omitir</button>
                                                </p>
                                            </div>
                                            <div className="col-6">
                                                <p className="buttons text-center">
                                                    <button type="submit" className="btn btn-primary btn-main no-hover">
                                                        {isLoading ? <Loading /> : 'Enviar'}
                                                    </button>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="row d-none d-md-flex mt-4 update-account">
                                            <p className="text-center">
                                            Si no tienes cuenta regístrate aquí <u><a href="https://afiliacion.bonus.pe/bonusvirtual/servlet/bonus.inicio?0011,1100" target="_bonus" className="text-white">bonus.pe</a></u>
                                            </p>
                                        </div>
                                    </div>
                                    :
                                    <div className="col-12 step-2">
                                        <h3 className="text-center mb-5">Información personal</h3>
                                        <div className="row data mt-3">
                                            <div className="col-12">
                                                <label>Nombre y apellido</label>
                                                <p>{userBonus.nombre_razonsocial} {userBonus.apellido_paterno} {userBonus.apellido_materno}</p>
                                                <label>Correo electrónico</label>
                                                <p>{userBonus.ultimo_email_registrado}</p>
                                                <label>Teléfono móvil</label>
                                                <p>{userBonus.ultimo_telefono_registrado}</p>
                                            </div>
                                            <div className="col-12 d-none d-md-flex mt-5 update-account">
                                                <p className="text-center">
                                                    Si quieres actualizar tus datos entra a <a href="https://bonus.pe/" target="_bonus">bonus.pe</a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="row d-md-none">
                                {stepProcess===1
                                    ?
                                    <div className="col-12 step-1">
                                        <div className="row">
                                            <div className="col-6">
                                                <p className="buttons text-center">
                                                    <button type="button" onClick={(event) => handleConfirm(event)} className="btn btn-primary btn-main no-hover">Omitir</button>
                                                </p>
                                            </div>
                                            <div className="col-6">
                                                <p className="buttons text-center">
                                                    <button type="submit" className="btn btn-primary btn-main no-hover">Enviar</button>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="row d-md-none update-account">
                                            <p className="text-center">
                                                Si quieres actualizar tus datos entra a <a href="https://bonus.pe/" target="_bonus" className="text-white">bonus.pe</a>
                                            </p>
                                        </div>
                                    </div>
                                    :
                                    <div className="col-12 step-2 d-md-none update-account">
                                        <p className="text-center">
                                            Si quieres actualizar tus datos entra a <a href="https://bonus.pe/" target="_bonus">bonus.pe</a>
                                        </p>
                                    </div>
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
};

PopupBonusReg.propTypes = {
    execActionConfirm: PropTypes.func
};
export default PopupBonusReg;
